<template>
  <div id="app">
    <Nav></Nav>
    <transition name="page" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Arimo:wght@400;700&display=swap');
  @import "~bulma/sass/utilities/_all";

  $primary: #670DDB;
  $primary-invert: findColorInvert($primary);
  $warning: #FFDD57;
  $warning-invert: findColorInvert($warning);
  $colors: (
    "primary": ($primary, $primary-invert),
    "warning": ($warning, $warning-invert)
  );
  $link: $primary;

  $arimo: "Arimo", sans-serif;
  $family-primary: $arimo;
  $body-family: $arimo;
  h1, h2, h3, h4, h5, h6 {
    font-family: $arimo;
    font-weight: 700 !important;
  }
  $button-family: $arimo;

  $input-shadow: none;
  $input-radius: 0px;
  $button-radius: 0px;

  .button {
    font-weight: 700 !important;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  p {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  .caption {
    font-size: 16px;
    color: #888888;
  }

  .container {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 36px;
    padding-bottom: 36px;
  }

  .messageContainer {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .bbox, .bbbox {
    margin: 2.8%;
    border: solid 1px #dfdfdf;
  }

  .bbbox {
    padding: 24px;
    font-size: 18px;
  }

  #app {
    margin-top: 48px;
  }

  .page-leave-active {
    transition: opacity 0.32s, transform 0.32s;
  }

  .page-enter-active {
    transition: opacity 0.48s, transform 0.48s;
  }

  .page-leave-to {
    opacity: 0;
  }

  .page-enter {
    opacity: 0;
    transform: translateY(-20px);
  }

  @import "~bulma";
  @import "~buefy/src/scss/buefy";
</style>
<script>
    import Nav from "./components/Nav";
    export default {
        components: {Nav}
    }
</script>